/* æ±ç¶å¾ */
import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { Router } from '@angular/router';
@Component({
    selector: 'fc-chartbar',
    template: `
    <ngx-charts-bar-vertical *ngIf="fcType==='vertical'"
        [view]="fcView"
        [scheme]="fcScheme"
        [results]="fcData"
        [gradient]="_gradient"
        [xAxis]="_showXAxis"
        [yAxis]="_showYAxis"
        [legend]="_showLegend"
        [legendTitle]="fcLegendTitle"
        [showXAxisLabel]="_showXAxisLabel"
        [showYAxisLabel]="_showYAxisLabel"
        [xAxisLabel]="fcXAxisLabel"
        [yAyisLabel]="fcYAxisLabel"
        [barPadding]="_barPadding"
        (select)="_select($event)"
        (activate)="_activate($event)"
        (deactivate)="_deactivate($event)">
    </ngx-charts-bar-vertical>
    <ngx-charts-bar-horizontal *ngIf="fcType==='horizontal'"
        [view]="fcView"
        [scheme]="fcScheme"
        [results]="fcData"
        [gradient]="_gradient"
        [xAxis]="_showXAxis"
        [yAxis]="_showYAxis"
        [legend]="_showLegend"
        [legendTitle]="fcLegendTitle"
        [showXAxisLabel]="_showXAxisLabel"
        [showYAxisLabel]="_showYAxisLabel"
        [xAxisLabel]="fcXAxisLabel"
        [yAyisLabel]="fcYAxisLabel"
        [barPadding]="_barPadding"
        (select)="_select($event)"
        (activate)="_activate($event)"
        (deactivate)="_deactivate($event)">
    </ngx-charts-bar-horizontal>
    <ngx-charts-bar-vertical-2d *ngIf="fcType==='groupedVertical'"
        [view]="fcView"
        [scheme]="fcScheme"
        [results]="fcData"
        [gradient]="_gradient"
        [xAxis]="_showXAxis"
        [yAxis]="_showYAxis"
        [legend]="_showLegend"
        [legendTitle]="fcLegendTitle"
        [showXAxisLabel]="_showXAxisLabel"
        [showYAxisLabel]="_showYAxisLabel"
        [xAxisLabel]="fcXAxisLabel"
        [yAyisLabel]="fcYAxisLabel"
        [barPadding]="_barPadding"
        (select)="_select($event)"
        (activate)="_activate($event)"
        (deactivate)="_deactivate($event)">
    </ngx-charts-bar-vertical-2d>
    <ngx-charts-bar-horizontal-2d *ngIf="fcType==='groupedHorizontal'"
        [view]="fcView"
        [scheme]="fcScheme"
        [results]="fcData"
        [gradient]="_gradient"
        [xAxis]="_showXAxis"
        [yAxis]="_showYAxis"
        [legend]="_showLegend"
        [legendTitle]="fcLegendTitle"
        [showXAxisLabel]="_showXAxisLabel"
        [showYAxisLabel]="_showYAxisLabel"
        [xAxisLabel]="fcXAxisLabel"
        [yAyisLabel]="fcYAxisLabel"
        [barPadding]="_barPadding"
        (select)="_select($event)"
        (activate)="_activate($event)"
        (deactivate)="_deactivate($event)">
    </ngx-charts-bar-horizontal-2d>
    `,
    styles: [`

    `]
})
export class FcchartbarComponent extends FcinputComponent {
     /**éç½®å¾è¡¨æ°æ®*/
    @Input()
    fcData: any[] = [];
     /**è§å¾å¤§å°,number[]å,å¦æä¸ä¼ ç»§æ¿ç¶çº§çå®½é«*/
    @Input()
    fcView: number[] = [];
     /**å¾è¡¨çèªå®ä¹é¢è²ãç¨äºè¦çç¹å®å¼çé¢è²*/
    @Input()
    fcScheme: any = { domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA'] };
     /** æ¾ç¤ºæéèxè½´*/
    @Input()
    fcShowXAxis: string;
    _showXAxis: boolean = true;
     /**æ¾ç¤ºæéèyè½´*/
    @Input()
    fcShowYAxis: string;
    _showYAxis: boolean = true;
     /**ç¨æ¸åå¡«ååç´ èä¸æ¯çº¯è²*/
    @Input()
    fcGradient: string;
    _gradient: boolean = false;
     /**æ¾ç¤ºæéèå¾ä¾*/
    @Input()
    fcShowLegend: string;
    _showLegend: boolean = true;
     /**å¾ä¾æ é¢*/
    @Input()
    fcLegendTitle: string = "å¾ä¾";
     /** æ¾ç¤ºæéèxè½´æ ç­¾*/
    _showXAxisLabel: boolean = true;
     /** æ¾ç¤ºæéèyè½´æ ç­¾*/
    _showYAxisLabel: boolean = true;
     /**xè½´æ ç­¾æå­*/
    @Input()
    fcXAxisLabel: string;
     /**yè½´æ ç­¾æå­*/
    @Input()
    fcYAxisLabel: string;
     /**å¾è¡¨ç±»å,åæ¬åç´æ¡å½¢å¾'vertical',æ°´å¹³æ¡å½¢å¾'horizontal',åç»åç´æ¡å½¢å¾'groupedVeritical',åç»*/
     /**,åç»æ°´å¹³æ¡å½¢å¾'group',å ç§¯åç´æ¡å½¢å¾'group',å ç§¯çæ°´å¹³æ¡å½¢å¾'group',æ ååæ°´å¹³æ¡å½¢å¾'group'*/
    @Input()
    fcType: string = 'vertical';
     /**é´é*/
    @Input()
    fcBarPadding: string;
    _barPadding: number = 8;
     /**åç»é´é*/
    @Input()
    fcGroupPadding: string;
    _groupPadding: number = 16;
    constructor(public provider: ProvidersService, private router: Router) {
        super(provider, 'fc-chartbar');
    }
    _afterParentInit() {
         /**æ¾ç¤ºæéèxè½´,é»è®¤æ¾ç¤ºxè½´*/
        if (this.fcShowXAxis === 'N') {
            this._showXAxis = false;
        } else {
            this._showXAxis = true;
        }
         /**æ¾ç¤ºæéèyè½´,é»è®¤æ¾ç¤ºyè½´*/
        if (this.fcShowYAxis === 'N') {
            this._showYAxis = false;
        } else {
            this._showYAxis = true;
        }
         /**æ¾ç¤ºæéèxè½´æ ç­¾ï¼é»è®¤æ¾ç¤ºxè½´æ ç­¾*/
        if (this.fcXAxisLabel !== undefined) {
            this._showXAxisLabel = true;
        } else {
            this._showXAxisLabel = false;
        }
         /**æ¾ç¤ºæéèyè½´æ ç­¾ï¼é»è®¤æ¾ç¤ºyè½´æ ç­¾*/
        if (this.fcYAxisLabel !== undefined) {
            this._showYAxisLabel = true;
        } else {
            this._showYAxisLabel = false;
        }
         /**æ¾ç¤ºæéèå¾ä¾,é»è®¤æ¾ç¤ºå¾å*/
        if (this.fcShowLegend === 'N') {
            this._showLegend = false;
        } else {
            this._showLegend = true;
        }
         /**ç¨æ¸åå¡«ååç´ èä¸æ¯çº¯è²*/
        if (this.fcGradient === 'Y') {
            this._gradient = true;
        } else {
            this._gradient = false;
        }
         /**é´é*/
        if (this.fcBarPadding !== undefined) {
            this._barPadding = Number(this.fcBarPadding);
        }
         /**åç»é´é */
        if (this.fcGroupPadding !== undefined) {
            this._groupPadding = Number(this.fcGroupPadding);
        }
    }
    /**
     * éä¸­ 
     * @param event 
     */
    _activate(event) {
        this.event('activate', event);
    }
    /**
     * åç´ æ¿æ´»äºä»¶ï¼é¼ æ è¾å¥ï¼
     * @param event 
     */
    _deactivate(event) {
        this.event('deactivate', event);
    }
    /**
     * åç´ åç¨äºä»¶ï¼é¼ æ ç¦»å¼ï¼
     * @param select 
     */
    _select(event) {
        this.event('select', event);
    }
}
